import { render, staticRenderFns } from "./ImageWithProducts.vue?vue&type=template&id=270b131f"
import script from "./ImageWithProducts.vue?vue&type=script&lang=js"
export * from "./ImageWithProducts.vue?vue&type=script&lang=js"
import style0 from "./ImageWithProducts.vue?vue&type=style&index=0&id=270b131f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports